export const presetsActionTypes = {
  GET_PRESETS: "GET_PRESETS",
};
